module.exports = __webpack_public_path__ + "img/auth-page--image.b00be7aa.svg";